import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let id = useDataValue({
    context: 'charge',
    path: 'type_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => ({ ...data, id }), [data, id])
}
